import {Map} from 'immutable'

const defaultMap = Map({
    'fetched': false,
    'fetching': false,
    'lastFetched': null,
    'state': null
})

const get = (state, name) => {
    return state.getIn(['network', name], defaultMap)
}

const create = (name)=> {
    return {
        'request':()=> {return {type: name+' requested'}},
        'success':()=> {return {type: name+' succeeded'}},
        'failure':(error, res)=> {return {type: name+' failed', errorMsg: error, response: res}},
        'getFrom': (state) => state.getIn(['network', name], defaultMap)
    }
}


export {
    get, create
}
export default {
    get, create
}



// WEBPACK FOOTER //
// ./src/model/Network/selector.js